const S3_DOCUMENT_HOST_PATTERN =
  /^origo-product-management-api-[a-z0-9-]+\.s3\.[a-z0-9-]+\.amazonaws\.com$/i;

const ensureTrailingSlash = path => {
  if (path) {
    if (!path.endsWith("/")) {
      path += "/";
    }
  }
  return path;
};

export const isSafeExcelReportUrl = reportUrl => {
  if (typeof reportUrl !== "string" || !reportUrl.trim()) {
    return false;
  }

  try {
    const url = new URL(reportUrl);

    return (
      url.protocol === "https:" && S3_DOCUMENT_HOST_PATTERN.test(url.hostname)
    );
  } catch {
    return false;
  }
};

export default ensureTrailingSlash;
